import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import LeaseTypeService from "../../services/LeaseTypeService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";


export default function AddLeaseType() {
  const [loading, setLoading] = useState(false); // form saving/loading
  const [editLoading, setEditLoading] = useState(false); // data fetching for edit
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [existingLeaseTypes, setExistingLeaseTypes] = useState([]);
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchExisting = async () => {
      try {
        const res = await LeaseTypeService.getAll();
        if (res.status === "true") {
          setExistingLeaseTypes(res.data.map((l) => l.leaseType.toLowerCase()));
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchExisting();

    if (id) {
      loadLeaseType(id);
    } else {
      setValue("leaseType", "");
    }
  }, [id, setValue]);

  const loadLeaseType = async (leaseId) => {
    setEditLoading(true); // 🔄 show spinner while loading edit data
    try {
      const res = await LeaseTypeService.getById(leaseId);

      if (!res) {
        showMessage("Lease Type not found");
        return;
      }

      setEditMode(true);
      setEditId(leaseId);

      setValue("leaseType", res.leaseType || "");
    } catch (err) {
      console.error(err);
      showMessage("Error loading lease type.");
    } finally {
      setEditLoading(false); // ✅ stop spinner
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      let res;

      if (editMode && editId) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await LeaseTypeService.update(editId, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await LeaseTypeService.create(data);
      }

      console.log("Save Response:", res);

      if (res.status === "error" && res.message?.toLowerCase().includes("exists")) {
        showMessage("Lease Type already exists!", "error");
        setLoading(false);
        return;
      }

      if (res.status === "error") {
        showMessage(res.message || "Something went wrong!", "error");
        setLoading(false);
        return;
      }

      showMessage(
        editMode
          ? "Lease type updated successfully."
          : "Lease type added successfully.",
        "success"
      );

      setTimeout(() => navigate("/cpnl/leasetype/view"), 800);
    } catch (error) {
      console.error("Error saving lease type:", error);
      showMessage("Error saving lease type", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("editLease");
    navigate("/cpnl/leasetype/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Lease Type" : "Add Lease Type"}
        secondTitle="Masters"
      />

      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center mb-3 p-2`}
        >
          <span>{message}</span>
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage("")}
          />
        </div>
      )} */}

      
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Lease Type <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.leaseType ? "is-invalid" : ""
                      }`}
                    placeholder="Enter Lease Type"
                    disabled={loading}
                    // {...register("leaseType", {
                    //   required: "Lease type is required",
                    //   pattern: {
                    //     value: /^[A-Za-z0-9\s]+$/,
                    //     message: "Only letters and numbers allowed",
                    //   },
                    //   minLength: {
                    //     value: 2,
                    //     message: "Minimum 2 characters required",
                    //   },
                    // })}

                    {...register("leaseType")}
                  />

                  {errors.leaseType && (
                    <small className="text-danger">
                      {errors.leaseType.message}
                    </small>
                  )}
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="btn btn-primary btn-sm me-2"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editMode
                      ? "Updating..."
                      : "Saving..."
                    : editMode
                      ? "Update"
                      : "Save"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
